import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { fetchData } from "../../../api/cancuiApi";




const getTagList = (temperature_formula_data) => {
        let calculation_type = temperature_formula_data?.calculation_type;
        let pattern = /([A-Za-z0-9_]+\.[A-Za-z0-9\._]+)/g;
        var tags = []
        let display_formula = ""
        let result = {};
        switch(calculation_type){
            case "DIRECT":
            case "AVG":
            case "ARITHMETIC":
                // Extract tags as list from temperature_rule using regex
                tags = temperature_formula_data?.temperature_rule?.match(pattern);
                // unique tags
                result["tags"] = [...new Set(tags)];
                result["display_formula"] = calculation_type == "DIRECT_PRESSURE_LOOKUP" ? `LOOKUP(${temperature_formula_data?.temperature_rule})` : temperature_formula_data?.temperature_rule;
                return result;
            case "COMPLEX_1":
            case "COMPLEX_2":
            case "DIRECT_PRESSURE_LOOKUP":
            case "SIMPLE_PRESSURE_FORMULA":
            case "SIMPLE_TEMPERATURE_FORMULA":
                let above_threshold_tag = temperature_formula_data?.above_threshold_tag;
                let below_threshold_tag = temperature_formula_data?.below_threshold_tag;
                let multiplier = temperature_formula_data?.multiplier;
                let threshold_value = temperature_formula_data?.threshold_value;
                let threshold_tag = temperature_formula_data?.threshold_tag;
                console.log("Tags in COMPLEX_2:", above_threshold_tag, below_threshold_tag, threshold_tag);
                tags = []
                if(above_threshold_tag && isNaN(parseFloat(above_threshold_tag))) tags.push(above_threshold_tag); // add above threshold tag only if it exists and is not a float/integer value
                if(below_threshold_tag) tags.push(below_threshold_tag);
                if(threshold_tag) tags.push(threshold_tag);
                tags = tags.map(tag => {
                    return tag.match(pattern)
                });
                console.log("Matched Tags in COMPLEX_2:", tags);
                tags = tags.flat();
                console.log("Flattened Tags in COMPLEX_2:", tags);
                // unique tags  
                result["tags"] = [...new Set(tags)];
                if (calculation_type === "COMPLEX_1") {
                    result["display_formula"] = `Temp = 0\ncount = 0\nsensors=(${threshold_tag.split(',').map((tag, index) => `${tag.trim()} : ${above_threshold_tag.split(',')[index].trim()}`).join('\t\n')})\n#sensors - flow sensors: temperature sensor\nfor each (x, y) in sensors:\n\tif x > ${threshold_value.split(',')[0]}:\n\t\tTemp = Temp + y\n\t\tcount = count + 1\n\nif count > 0:\n\tTemperature = Temp / count ${multiplier ? `* ${multiplier}` : ''}\nelse:\n\tTemperature = ${below_threshold_tag}`;
                    result["flow_tags"] = threshold_tag.split(',').map(tag => tag.trim());
                } else if (calculation_type === "COMPLEX_2") {
                    result["display_formula"] = `If ${threshold_tag}<${threshold_value}\n\tTemperature=${below_threshold_tag}\nelse\n\tTemp=0\n\tcount=0\ntags=${above_threshold_tag.split(',').join(',\n')}\nFor every tag in tags\n\tIF tag> ${threshold_value}\n\t\tcount=count+1\n\t\tTemp=Temp+tag\nif the count>0\n\tTemperature= Temp/count\nelse\n\tTemperature=${below_threshold_tag}`;
                } else if (calculation_type === "SIMPLE_TEMPERATURE_FORMULA") {
                    result["display_formula"] = `If ${threshold_tag}>${threshold_value}\n\tTemperature=${above_threshold_tag} °C\nelse\n\tTemperature=${below_threshold_tag}`;
                    result["flow_tags"] = [threshold_tag];
                } else if (calculation_type === "SIMPLE_PRESSURE_FORMULA") {
                    result["display_formula"] = `If ${threshold_tag}>${threshold_value}\n\tIf ${above_threshold_tag} < 0.987 barg\n\t\tTemperature=${below_threshold_tag}\n\telse\n\t\tTemperature=LOOKUP(${above_threshold_tag})\nelse\n\tTemperature=${below_threshold_tag}`;
                    result["pressure_tags"] = [above_threshold_tag];
                    result["flow_tags"] = [threshold_tag];
                } else if (calculation_type === "DIRECT_PRESSURE_LOOKUP") {
                    result["display_formula"] = `If ${temperature_formula_data?.temperature_rule} < 0.987 barg\n\tTemperature=${below_threshold_tag}\nelse\n\tTemperature=LOOKUP(${temperature_formula_data?.temperature_rule})`;
                    let pressure_tags = temperature_formula_data?.temperature_rule?.match(pattern);
                    result["pressure_tags"] = [...new Set(pressure_tags)];
                    result["tags"] = [...result["pressure_tags"], ...tags];
                }
                return result;
            case "CONDITIONAL_TEMPERATURE_CHECK_1": 
                let helper_tag1 = temperature_formula_data?.helper_tag1;
                let helper_tag2 = temperature_formula_data?.helper_tag2;
                let helper_tag3 = temperature_formula_data?.helper_tag3;
                let helper_tag4 = temperature_formula_data?.helper_tag4;
                let threshold_values = temperature_formula_data?.threshold_value?.split(',')?.map(value => value.trim()) || [];
                tags = [helper_tag1, helper_tag2, helper_tag3, helper_tag4].filter(Boolean);
                result["flow_tags"] = [helper_tag1, helper_tag3].filter(Boolean);
                result["tags"] = [...new Set(tags)];
                result["display_formula"] = `If ${helper_tag1}>${threshold_values?.[0]}\n\tTemperature=${helper_tag2}\nelif ${helper_tag3}>${threshold_values?.[1]}\n\tTemperature=${helper_tag4}\nelse\n\tTemperature=avg(${helper_tag2}, ${helper_tag4})`;
                return result;
            default:
                tags = temperature_formula_data?.temperature_rule?.match(pattern);
                return temperature_formula_data?.ambient_based_tags || [];
        }
    }

const getTemperatureFormulaData = async (id) => {
    const spec = { "sensor_id": id }


    try {
        const res = await fetchData("getTemperaturerule", spec);
        console.log(res);
        if (res && res.temperature_calculation_details) {
            console.log("Fetched temperature formula data:", res.temperature_calculation_details);
            return res.temperature_calculation_details;
        } else {
            return {}
        }

    } catch (error) {
        console.error("Error fetching dew series data:", error);
        toast.error("Error fetching dew series data. Please try again later.");
        return [];
    }
}



function useGetTemperatureFormulaData(id) {

    const [data, setData] = useState([]);
    const [tagList, setTagList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {

        async function fetchTemperatureFormulaData() {
            if (id) {
                setIsLoading(true);
                try {
                    console.log("Fetching temperature formula data for id:", id);
                    // Fetch temperature formula data
                    const temperature_formula_data = await getTemperatureFormulaData(id);
                    setData(temperature_formula_data);
                    const tagList = getTagList(temperature_formula_data);
                    setTagList(tagList);
                }
                catch (error) {
                    console.error("Error fetching temperature formula data:", error);
                    toast.error("Error fetching temperature formula data. Please try again later.");
                } finally {
                    console.log("Finished fetching temperature formula data.");
                    setIsLoading(false);
                }

            }
        }
        fetchTemperatureFormulaData();

    }, [id]);

    return {
        data,
        tagList,
        isLoading
    };
}
export default useGetTemperatureFormulaData;